<template>
  <LmDialog v-model="modalShow" :title="toolbarTitle">
    <template #toolbar-actions>
      <q-btn :disable="created" size="sm" label="Save" color="tertiary" @click="process" />
    </template>

    <template #content>
      <q-splitter :value="splitterModel" :disable="true" style="overflow: auto">
        <template #before>
          <q-tabs v-model="activeTab" vertical class="text-teal">
            <q-tab name="basic" label="Basic" />
            <q-tab name="metaData" label="Metadata" />
          </q-tabs>
        </template>

        <template #after>
          <q-tab-panels v-model="activeTab" keep-alive animated transition-prev="scale" transition-next="scale">
            <q-tab-panel name="basic">
              <q-card-section :style="{ minHeight: '600px' }" class="row q-col-gutter-md relative-position">
                <div class="col-xs-3">
                  <div class="input__wrapper">
                    <q-input
                      id="name"
                      v-model="$v.formData.name.$model"
                      :error="$v.formData.name.$error"
                      :error-message="$v_displayMessage($v.formData.name)"
                      label="Name *"
                      name="name"
                      type="text"
                      outlined
                    />
                  </div>
                </div>
                <div class="col-xs-3">
                  <div class="input__wrapper">
                    <q-input
                      id="alternative_name"
                      v-model="$v.formData.alternative_name.$model"
                      :error="$v.formData.alternative_name.$error"
                      :error-message="$v_displayMessage($v.formData.alternative_name)"
                      name="alternative_name"
                      type="text"
                      label="Alternative name"
                      outlined
                    />
                  </div>
                </div>
                <div class="col-xs-3">
                  <div class="input__wrapper">
                    <q-input
                      id="abbreviation"
                      v-model="$v.formData.abbreviation.$model"
                      :error="$v.formData.abbreviation.$error"
                      :error-message="$v_displayMessage($v.formData.abbreviation)"
                      name="abbreviation"
                      type="text"
                      label="Abbreviation"
                      outlined
                    />
                  </div>
                </div>
                <div class="col-xs-3">
                  <enhanced-q-select
                    id="currency"
                    v-model="$v.formData.currency.$model"
                    :error="$v.formData.currency.$error"
                    :error-message="$v_displayMessage($v.formData.currency)"
                    :options="currencies"
                    label="Currency list *"
                  />
                </div>
                <div class="col-xs-3">
                  <q-input
                    id="ringgold_id"
                    v-model="$v.formData.ringgold_id.$model"
                    :error="$v.formData.ringgold_id.$error"
                    :error-message="$v_displayMessage($v.formData.ringgold_id)"
                    name="ringgold_id"
                    type="text"
                    label="Ringgold id"
                    outlined
                  />
                </div>
                <div class="col-xs-3">
                  <enhanced-q-select id="owner_id" v-model="formData.owner_id" :options="ownerOptions" label="Owner" />
                </div>
                <div class="col-xs-3">
                  <q-input
                    id="website"
                    v-model="$v.formData.website.$model"
                    :error="$v.formData.website.$error"
                    :error-message="$v_displayMessage($v.formData.website)"
                    name="website"
                    type="url"
                    label="Website"
                    outlined
                  />
                </div>
                <div class="col-xs-3 self-center q-mt-sm">
                  <q-checkbox
                    v-model="formData.active"
                    class="lm-checkbox"
                    color="tertiary"
                    label="is Active"
                    outlined
                  />
                </div>
                <template v-if="showing">
                  <div v-for="(address, index) of formData.addresses" :key="`address_${index}`" class="col-xs-6">
                    <address-form
                      :show-title="true"
                      :address-setting="address"
                      @address-updated="updateAddresses($event, index)"
                    />
                  </div>
                </template>
                <div v-if="!addressTypes.length" class="col-12 text-center content-center items-center justify-center">
                  <q-spinner-audio :size="30" style="height: 550px" class="self-center " color="primary" />
                </div>
              </q-card-section>
            </q-tab-panel>

            <q-tab-panel name="metaData">
              <q-card-section :style="{ minHeight: '600px' }">
                <ModalMetaData ref="metaData" :meta-data-fields="metaDataFields" />
              </q-card-section>
            </q-tab-panel>
          </q-tab-panels>
          <q-card-actions align="right">
            <div v-if="newProvider" class="row q-pr-lg q-pb-sm justify-end">
              <q-btn :label="stayLabel" size="sm" color="positive" @click="closeModal" />
              <q-btn
                :to="{ name: `${entityName}`, params: { id: newProvider.id } }"
                :label="goLabel"
                color="tertiary"
                size="sm"
                class="on-right"
              />
            </div>
          </q-card-actions>
        </template>
      </q-splitter>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep, get } from 'lodash'
import { validations } from './validations'
// Components
import EnhancedQSelect from '@components/general/EnhancedQSelect'
import AddressForm from '@components/lm-blocks/Address'
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'
import ModalMetaData from '@/reusable/ModalMetaData'

export default {
  name: 'FormCreateProvider',
  components: {
    EnhancedQSelect,
    AddressForm,
    LmDialog,
    ModalMetaData
  },
  mixins: [validations],
  props: {
    showing: Boolean,
    providerName: String,
    namespace: {
      type: String,
      required: true
    },
    entityName: {
      type: String,
      required: true
    },
    editable: Object,
    stayLabel: {
      type: String,
      required: true
    },
    goLabel: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      formData: {},
      dataTemplate: {
        name: null,
        active: true,
        alternative_name: null,
        abbreviation: null,
        currency: null,
        ringgold_id: null,
        owner_id: null,
        website: null,
        addresses: []
      },
      created: false,
      addressToCopy: null,
      newProvider: null,
      activeTab: 'basic',
      splitterModel: 10
    }
  },
  computed: {
    addressTypes() {
      return get(this.$store, `state.${this.namespace}.addressTypes`, [])
    },
    modalShow: {
      get() {
        return this.showing
      },
      set(value) {
        if (!value) {
          this.$emit('close')
          this.activeTab = 'basic'
          this.$v.$reset()
          if (this.$refs.metaData) this.$refs.metaData.resetValidation()
        }
      }
    },
    owners() {
      return get(this.$store, `state.${this.namespace}.owners`, [])
    },
    ownerOptions() {
      return this.generateOptions({
        collection: this.owners,
        includeNone: true,
        noneLabel: 'None',
        sort: false,
        sortBefore: true,
        sortingOptions: {
          sortDataType: 'string',
          sortBy: 'name',
          sortOrder: 'asc'
        }
      })
    },
    toolbarTitle() {
      return `Create ${this.entityName}`
    },
    metaDataFields() {
      return this.$store.getters[`${this.namespace}/metaDataFields`]
    }
  },
  watch: {
    addressTypes: {
      immediate: true,
      deep: true,
      handler: function(newVal) {
        this.populateAddresses(newVal)
      }
    },
    editable: {
      immediate: true,
      deep: true,
      handler: function(newVal) {
        this.formData = newVal ? new LmFormObject(newVal) : new LmFormObject(cloneDeep(this.dataTemplate))
        this.populateAddresses(this.addressTypes)
      }
    },
    formData(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return
      if (!newVal.addresses || !newVal.addresses.length) this.populateAddresses(this.addressTypes)
    }
  },
  created() {
    this.formData = new LmFormObject(cloneDeep(this.dataTemplate))
    this.formData.name = this.providerName
    if (!this.addressTypes || !this.addressTypes.length) {
      this.$store.dispatch(`${this.namespace}/getCreateFormData`)
    }
  },
  methods: {
    process() {
      if (!this.$v_validationPass()) return
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      for (let key in this.formData) {
        this.checkField(key)
      }

      if (this.$refs.metaData) {
        data.meta_data_fields_by_category = this.$refs.metaData.getUpdatedMetaData()
      } else {
        data.meta_data_fields_by_category = this.metaDataFields
      }

      this.sendData(this.namespace, data)
    },

    checkField(key) {
      if (key !== 'active') this.formData[key] = this.formData[key] ? this.formData[key] : null
    },
    sendData(namespace, data) {
      let params = {
        namespace,
        value: data
      }
      let action = `${namespace}/create`
      return this.$store
        .dispatch(action, params)
        .then(result => {
          if (!get(result, 'errors')) {
            this.newProvider = result
            this.$emit('create', result)
            this.$emit('refresh')
          } else {
            this.created = false
          }
        })
        .catch(() => {
          this.created = false
        })
    },
    closeModal() {
      this.modalShow = false
      this.created = false
      this.resetFormData()
    },
    populateAddresses(types) {
      if (this.formData.hasOwnProperty('addresses') && !this.formData.addresses.length) {
        let addresses = []
        if (!types || !types.length) return
        for (let type of types) {
          let address = {
            address_1: '',
            address_2: '',
            post_code: '',
            city: '',
            state: '',
            country: '',
            use_address_type: null,
            address_type: type
          }
          if (type.name !== 'main') {
            address.use_address_type = types.find(type => type.name === 'main')
          }
          addresses.push(address)
        }
        this.$set(this.formData, 'addresses', addresses)
      }
    },
    updateAddresses(address, index) {
      let addresses = cloneDeep(this.formData.addresses)
      addresses[index] = address
      this.$set(this.formData, 'addresses', addresses)
      if (address.address_type.name === 'main') this.$set(this, 'addressToCopy', address)
    },
    resetFormData() {
      this.addressToCopy = null
      this.newProvider = null
      this.formData = new LmFormObject(cloneDeep(this.dataTemplate))
    }
  }
}
</script>

<style lang="stylus" scoped>
.q-card {
  width: 1200px;
  max-width: 1200px;
}
</style>
